<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 25H5a2 2 0 01-2-2V9a2 2 0 012-2h22a2 2 0 012 2v14a2 2 0 01-2 2zM5 8a1 1 0 00-1 1v14a1 1 0 001 1h22a1 1 0 001-1V9a1 1 0 00-1-1z"/><path d="M20.5 13h-.88A2.24 2.24 0 0016 10.35 2.25 2.25 0 0012.38 13h-.88a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5zm-.5 4h-3.5v-3H20zm-2.25-6.5a1.25 1.25 0 010 2.5H16.5v-1.25a1.25 1.25 0 011.25-1.25zM13 11.75a1.25 1.25 0 012.5 0V13h-1.25A1.25 1.25 0 0113 11.75zM14.25 14h1.25v3H12v-3zM12 18h3.5v3H12zm4.5 3v-3H20v3z"/></svg>